import React  from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';
import Flexbox from 'flexbox-react';
import { colorVeryLightYellow, colorBorderGrey, colorTextGrey, colorLightOrange } from 'styles/base';

const componentStyles = css`
    color: ${colorTextGrey};
    background-color: ${colorVeryLightYellow};
    border: 1px solid ${colorBorderGrey};
    border-radius: 3px;
    margin-top: 5px;
    .icon {
        color: ${colorLightOrange};
        margin-right:15px;
        justify-content: center;
    }
`;

export default class MessageBox extends React.Component {
    static propTypes = {
        includeIcon: PropTypes.bool,
        small: PropTypes.bool,
        children: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.string
            ]),
        className: PropTypes.string
    };

    static defaultProps = {
        includeIcon: false,
        small: false,
        className: ''
    };

    render() {
        const faSizeClass = this.props.small ? '' : 'fa-2x';

        const padding = this.props.small ? '5px 10px' : '10px 20px';
        const paddingBottom = this.props.small ? '0' : '5px';

        const boxPaddingStyles = css`
            padding: ${padding};
            .icon {
                padding-bottom: ${paddingBottom};
            }
        `;

        return (
            <Flexbox flexDirection={'row'} className={cx('message-box', componentStyles, boxPaddingStyles, this.props.className)}>
                {this.props.includeIcon &&
                <Flexbox flexDirection={'column'} className="icon">
                    <i className={`fa fa-warning ${faSizeClass}`}/>
                </Flexbox>
                }
                {this.props.children}
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/MessageBox.js